import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { useCMS } from "@/hooks/useCMS";

export function SocialRail() {
  const { data } = useCMS();
  const s = data.settings || {};
  const items = [
    { icon: Instagram, href: s.social_instagram, label: "Instagram" },
    { icon: Facebook, href: s.social_facebook, label: "Facebook" },
    { icon: Youtube, href: s.social_youtube, label: "YouTube" },
    { icon: Music2, href: s.social_tiktok, label: "TikTok" },
  ];
  return (
    <div className="hidden lg:flex fixed right-5 top-1/2 -translate-y-1/2 z-40 flex-col gap-2 rounded-full bg-[#0F172A] p-2 shadow-xl" data-testid="social-rail">
      {items.map((it) => (
        <a
          key={it.label}
          href={it.href || "#"}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={it.label}
          data-testid={`rail-social-${it.label.toLowerCase()}`}
          className="flex h-10 w-10 items-center justify-center rounded-full text-white/80 hover:bg-[#2CACD4] hover:text-slate-950 transition-colors cursor-pointer"
        >
          <it.icon size={18} />
        </a>
      ))}
    </div>
  );
}
